import { createElement, Component } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_container__2pRR5 {\n  width: 100%;\n  height: 25px;\n}\n\n.styles_emojiBar__3xacr {\n  width: 100%;\n  height: 27px;\n  margin-bottom: 0.25vw;\n}\n\n.styles_emojiBar__3xacr > div > img {\n  height: 100%;\n}\n\n.styles_emojiBar__3xacr > div {\n  position: relative;\n  height: 100%;\n  margin-left: -3%;\n  display: inline-block;\n}\n\n.styles_zero__xda8r {\n  left: 0%;\n}\n\n.styles_outer__abXQX {\n  width: 100%;\n  height: 25px;\n  background-color: #f3eef2;\n  border-radius: 20px;\n  display: flex;\n  justify-content: left;\n}\n\n.styles_inner__x-amJ {\n  height: 100%;\n  border-radius: 22px;\n}\n\n.styles_percentage__3856Y {\n  float: right;\n  color: #fff;\n  margin-top: 1vw;\n}\n";
var styles = {"container":"styles_container__2pRR5","emojiBar":"styles_emojiBar__3xacr","zero":"styles_zero__xda8r","outer":"styles_outer__abXQX","inner":"styles_inner__x-amJ","percentage":"styles_percentage__3856Y"};
styleInject(css);

var Twemoji = require('react-twemoji').default;
var Posed = require('react-pose').default;
var EmojiDiv = Posed.div({
    visible: { opacity: 1, position: 'relative', top: -10, transition: { type: 'spring', stiffness: 200 } },
    hidden: { opacity: 0, position: 'relative', top: 0, transition: { type: 'spring', stiffness: 100, duration: 10 } }
});
var EmojiProgressBar = /** @class */ (function (_super) {
    __extends(EmojiProgressBar, _super);
    function EmojiProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComplete = false;
        _this.adjustBrightness = function (col, amt) {
            var usePound = false;
            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }
            var R = parseInt(col.substring(0, 2), 16);
            var G = parseInt(col.substring(2, 4), 16);
            var B = parseInt(col.substring(4, 6), 16);
            R = R + amt;
            G = G + amt;
            B = B + amt;
            if (R > 255)
                R = 255;
            else if (R < 0)
                R = 0;
            if (G > 255)
                G = 255;
            else if (G < 0)
                G = 0;
            if (B > 255)
                B = 255;
            else if (B < 0)
                B = 0;
            var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
            var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
            var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));
            return (usePound ? "#" : "") + RR + GG + BB;
        };
        return _this;
    }
    EmojiProgressBar.prototype.componentDidUpdate = function () {
        if (this.props.progress >= 100 && !this.isComplete && this.props.onComplete) {
            this.props.onComplete();
            this.isComplete = true;
        }
        if (this.isComplete && this.props.progress < 100) {
            this.isComplete = false;
        }
    };
    EmojiProgressBar.prototype.render = function () {
        return (createElement("div", { className: styles.container },
            createElement(Twemoji, { className: styles.emojiBar, options: { className: 'twemoji' } },
                createElement(EmojiDiv, { pose: this.props.progress >= 10 && this.props.progress < 15 ? 'visible' : 'hidden', style: { left: '10%', display: this.props.progress >= 10 && this.props.progress < 20 ? 'block' : 'none' } }, "\uD83D\uDE16"),
                createElement(EmojiDiv, { pose: this.props.progress >= 20 && this.props.progress < 25 ? 'visible' : 'hidden', style: { left: '20%', display: this.props.progress >= 20 && this.props.progress < 30 ? 'block' : 'none' } }, "\uFE0F\u2639\uFE0F"),
                createElement(EmojiDiv, { pose: this.props.progress >= 30 && this.props.progress < 35 ? 'visible' : 'hidden', style: { left: '30%', display: this.props.progress >= 30 && this.props.progress < 40 ? 'block' : 'none' } }, "\uD83D\uDE15"),
                createElement(EmojiDiv, { pose: this.props.progress >= 40 && this.props.progress < 45 ? 'visible' : 'hidden', style: { left: '40%', display: this.props.progress >= 40 && this.props.progress < 50 ? 'block' : 'none' } }, "\uD83E\uDD28"),
                createElement(EmojiDiv, { pose: this.props.progress >= 50 && this.props.progress < 55 ? 'visible' : 'hidden', style: { left: '50%', display: this.props.progress >= 50 && this.props.progress < 60 ? 'block' : 'none' } }, "\uD83D\uDE10"),
                createElement(EmojiDiv, { pose: this.props.progress >= 60 && this.props.progress < 65 ? 'visible' : 'hidden', style: { left: '60%', display: this.props.progress >= 60 && this.props.progress < 70 ? 'block' : 'none' } }, "\uD83D\uDE42"),
                createElement(EmojiDiv, { pose: this.props.progress >= 70 && this.props.progress < 75 ? 'visible' : 'hidden', style: { left: '70%', display: this.props.progress >= 70 && this.props.progress < 80 ? 'block' : 'none' } }, "\uD83D\uDE09"),
                createElement(EmojiDiv, { pose: this.props.progress >= 80 && this.props.progress < 85 ? 'visible' : 'hidden', style: { left: '80%', display: this.props.progress >= 80 && this.props.progress < 90 ? 'block' : 'none' } }, "\uD83D\uDE18"),
                createElement(EmojiDiv, { pose: this.props.progress >= 90 && this.props.progress < 95 ? 'visible' : 'hidden', style: { left: '90%', display: this.props.progress >= 90 && this.props.progress < 100 ? 'block' : 'none' } }, "\uD83D\uDE03"),
                createElement(EmojiDiv, { pose: this.props.progress >= 100 ? 'visible' : 'hidden', style: { left: '100%', display: this.props.progress >= 100 ? 'block' : 'none' } }, "\uD83D\uDE01")),
            createElement("div", { className: styles.outer, style: { border: "solid " + (this.props.color ? this.adjustBrightness(this.props.color, -30) : this.adjustBrightness('#eb4b8a', -30)) + " 4px" } },
                createElement("div", { className: styles.inner, style: { width: this.props.progress.toString() + "%", backgroundColor: this.props.color ? this.props.color : '#eb4b8a' } })),
            this.props.showPercentage ? createElement("div", { className: styles.percentage }, this.props.progress <= 100 ? Math.round(this.props.progress) + "%" : '100%') : null));
    };
    return EmojiProgressBar;
}(Component));
//# sourceMappingURL=index.js.map

export default EmojiProgressBar;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 48
// module chunks = 0